import { AnalyticsRoutes } from '@agilox/common';

export function getEnvironmentFromUrl(url: string): string {
	const env = Object.keys(AnalyticsRoutes).find((key) => url.includes(AnalyticsRoutes[key]));
	return env || 'Live';
}
